import { render, staticRenderFns } from "./wjPatrolStandardLookList.vue?vue&type=template&id=60a1cb50&"
import script from "./wjPatrolStandardLookList.vue?vue&type=script&lang=js&"
export * from "./wjPatrolStandardLookList.vue?vue&type=script&lang=js&"
import style0 from "./wjPatrolStandardLookList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports